<template>
    <div>
        <h4 class="switch-title">
            {{ $t('menu.public_tools') }}
        </h4>
        <div class="switch-item-list">
            <div class="switch-item" v-for="(data_switch, key_switch, idx_switch) in switches" :key="idx_switch">
                <div class="switch-item-name">{{ $t( data_switch.name ) }}</div>
                <label class="switch switch-success">
                    <input type="checkbox" class="switch-input" v-model="data_switch.value" @change="update_Public_Switch( key_switch, data_switch )">
                    <span class="switch-slider"></span>
                </label>
                <div class="switch-item-link" v-if="data_switch.value == true && data_switch.link != undefined">
                    <div class="switch-item-link-goto">
                        <a :href="data_switch.link" target="_blank"><i class="fa fa-external-link-square"></i></a>
                    </div>

                    <div class="switch-item-link-copy">
                        <BtnCopyToClipboard
                            :copy_content="data_switch.link"
                            :btn_text="$t('menu.copy_link')"
                            btn_style="p-1 m-0" :btn_variant="'outline-warning'" :show_tooltip="false">
                        </BtnCopyToClipboard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AgriLoading  from '@/views/components/AgriLoading'
import BtnCopyToClipboard from '@/views/components/Button_CopyToClipboard'

export default {
    props: {
        cropperiodID: {
            type: [String, Number],
            default: undefined,
        },
        projectDetail: {
            type: Object,
            default: function () { return {} },
        },
        cropperiodDetail: {
            type: Object,
            required: true,
        },
    },
    components: {
        AgriLoading,
        BtnCopyToClipboard,
    },
    data () {
        return {
            loading: false,
            uploading: false,
            origin_data: {},
            switches: {
                'dashboard': {
                    value: false,
                    name: 'menu.public_dashboard', //'公開儀錶板',
                    description: '',
                    link: undefined,
                },
            },
        }
    },
    mounted ()
    {
        this.set_Switches()
    },
    watch: {

        cropperiodDetail (val, oldVal)
        {
            this.set_Switches()
        },

    },
    methods: {

        emit_Update ()
        {
            this.$emit('update', true);
        },

        set_Switches ()
        {
            if ( this.cropperiodDetail != undefined )
            this.switches['dashboard'].value = this.cropperiodDetail.is_public
            let _path_dashboard = this.$router.resolve( { name: 'Public Dashboard', params: { cropperiod_uuid: this.cropperiodDetail.uuid } } ).href
            this.switches['dashboard'].link = location.origin + _path_dashboard
        },

        update_Public_Switch (switch_key, switch_data)
        {
            this.uploading = true;
            let options = undefined

            if ( switch_key == 'dashboard' )
            {
                if ( switch_data.value == true ) {
                    options = {
                        method: 'POST',
                        url: this.$config.getAPI_URL('Cropperiod_PublicSwitch', { cropperiodID: this.cropperiodID }),
                    }
                }
                else {
                    options = {
                        method: 'DELETE',
                        url: this.$config.getAPI_URL('Cropperiod_PublicSwitch', { cropperiodID: this.cropperiodID }),
                    }
                }
            }

            if ( options != undefined )
            {
                this.$http(options)
                .then(res => {
                    // this.getCropperiod(this.cropInfo.id);
                    this.uploading = false;
                    this.$toastr.s(this.$t('other.update_succeeded'), this.$t('menu.public_tools'));
                    this.emit_Update()
                })
                .catch(err => {
                    this.uploading = false;
                    this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                    this.$t('menu.public_tools'));
                })

                // 送出使用者操作紀錄 --------------------
                let _query = {}
                _query[ switch_key ] = switch_data.value

                let _OPLog = {
                    user_id: this.$store.state.user.id,
                    type: 'write',
                    detail: {
                        page: 'cropperiod',
                        action: 'update public tools switch',
                        querySettings: _query,
                        pageInfo: {
                            'project ID':    this.projectDetail.id,
                            'project name':  this.projectDetail.name,
                            'cropperiod ID':    this.cropperiodDetail.id,
                            'cropperiod name':  this.cropperiodDetail.name,
                            'cropperiod status': this.cropperiodDetail.status,
                        },
                    },
                }
                this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
                // 送出使用者操作紀錄 --------------------
            }
        },
    },
}
</script>

<style lang="scss" scoped>

.switch-title
{
    color: #3b7564;
    padding: 5px 15px 10px 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #badf8a;
}
.switch-item-list
{
    text-align: left;
}
.switch-item
{
    margin: 8px 0px;
}
.switch-item-name
{
    display: inline-block;
    vertical-align: top;
    margin-right: 8px;
    font-size: 1.2rem;
}
.switch-item-link
{
    display: inline-block;
    vertical-align: top;
    margin-top: -2px;
    margin-left: 20px;

    .switch-item-link-goto
    {
        display: inline-block;
        vertical-align: middle;
        font-size: 2.0rem;
        line-height: 2.0rem;
        margin-right: 5px;
    }
    .switch-item-link-copy
    {
        display: inline-block;
        vertical-align: middle;

    }
}

</style>
